import { createFileRoute } from "@tanstack/react-router";

import { TeamSettingsPanel } from "../components/settings/TeamSettings";

export const Route = createFileRoute("/settings/team")({
  component: TeamSettingsPanel,
});
